<template>
    <div id="setting-docs-app-entry">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
